/*eslint-disable*/
import './styles.scss'
import React, { useContext, useEffect, useState } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { RouteStrings } from 'Utils/Routes/RouteStrings'
import { ROUTE_STRINGS } from 'Utils/Constants'
import CoffeeNewsFeeds from 'Screens/CoffeeNewsFeeds'
import PaymentGateWay from 'Screens/Subscription/Pages/PaymentGateway'
import SupportRequest from 'Screens/SupportRequest'
import PageNotFound from 'Screens/PageNotFound'
import Subscription from 'Screens/Subscription'
import OpenSharedNews from 'Screens/NewsFeedLink/Pages/OpenSharedNews'
import OpenNewsNotification from 'Screens/Notification/Pages/OpenNewsNotification'
import Notification from 'Screens/Notification'
import PaymentStatus from 'Screens/Subscription/Pages/PaymentStatus'
import Menubar from '../Menubar'
import Header from '../Header'
import FooterDashboard from '../Footer/FooterDashboard'
import CoffeeQuotes from 'Screens/CoffeeQuotes'
import GlobalDifferentials from 'Screens/GlobalDifferentials'
import AboutUs from 'Screens/AboutUs'
import GuestNewsFeed from 'Screens/CoffeeNewsFeeds/Components/GuestNewsFeed'
import NewsFeedLink from 'Screens/NewsFeedLink'
import AuthScreens from 'Screens/AuthScreens'
import FreeMenubar from '../FreeUserMenubar'
import { getLocalFreeMenus, getLocalFreeBusinessGeneralMenus, getLocalUserDetails, setLocalWithFreeMenus, setLocalWithFreeBusinessGeneralMenus } from 'Utils/LocalStorage_Handler'
import { getAllFreeBusinessGeneralMenuToDisplay } from 'Services/apiAdapter_CoffeeWeb'
import { CoffeeWebContext } from 'Context/CoffeeWebContext'
import LayoutContainer from '../LayoutContainer'
import CoffeeStockReports from 'Screens/CoffeeReports'
import GlobalRawCoffeePrices from 'Screens/GlobalRawCoffeePrices'
import BillionaireBrew from 'Screens/BillionaireBrews'
import UserGuide from 'Screens/UserGuide'
import SharedNewsRedirection from 'Screens/CoffeeNewsFeeds/Components/ShareNewsfeed/SharedNewsRedirect'
import CoffeeWebAi from 'Screens/CoffeeWebAi'
import CoffeeWebSocial from 'Screens/CoffeeWebSocial'
import CoffeeGames from 'Screens/CoffeeGames'
import CoffeeWebQuiz from 'Screens/CoffeeGames/Pages/CoffeeWebQuiz'
import Weather from 'Screens/Weather'
import CoffeeCart from 'Screens/CoffeeWebSocial/Components/CoffeeCart'
import CoffeePostScreen from 'Screens/CoffeeWebSocial/Components/CoffeePost'
import GlobalFreightRates from 'Screens/GlobalFreightRates'
import CoffeeCafes from 'Screens/CoffeeCafes'
import CoffeeTradeBox from 'Screens/CoffeeTradeBox'
import CoffeeExchange from 'Screens/CoffeeExchange'
import CoffeeApps from 'Screens/CoffeeApps'
import CoffeePedia from 'Screens/CoffeePedia'
import YourNews from 'Screens/YourNews'
const Routes = () => {
  const pageUrl = window.location.pathname
  const params = new URLSearchParams(window.location.search)
  const view = params.get('view')
  const splitPageUrl = pageUrl.split('/')
  const currentUrl = splitPageUrl.pop()
  const { isLoading, isCustomLoading } = useContext(CoffeeWebContext)
  const userDetails = getLocalUserDetails()
  const freeMenusToDisplay = getLocalFreeMenus()
  const freeBusinessGeneralMenusToDisplay = getLocalFreeBusinessGeneralMenus()
  const showFooter = process.env.REACT_APP_SHOW_FOOTER === 'true'

  let guestMenus = null

  const [guestUserMenus, setGuestUserMenus] = useState(freeBusinessGeneralMenusToDisplay)
  const hideViews = ['coffeecast', 'coffeecart', 'coffee-games', 'coffee-community']

  useEffect(() => {
    getAllFreeMenusToDisplay()
  }, [])

  const getAllFreeMenusToDisplay = async () => {
    try {
      const response = await getAllFreeBusinessGeneralMenuToDisplay()

      if (response?.data?.returnLst) {
        guestMenus = response?.data?.returnLst

        setLocalWithFreeBusinessGeneralMenus(response.data?.returnLst)
        setGuestUserMenus(response?.data?.returnLst)
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  return (
    <div className="dashboard">
      <Header />
      {currentUrl !== 'login' && currentUrl !== 'create_account' && !userDetails && <FreeMenubar guestUserMenus={guestMenus || guestUserMenus} />}
      {userDetails && <Menubar />}
      <LayoutContainer isLoading={isLoading} isCustomLoading={isCustomLoading}>
        <Switch>
          {/* Open Routes */}
          <Route exact path={ROUTE_STRINGS.guestCoffeeWeb} component={CoffeeWebSocial} />
          <Route exact path={ROUTE_STRINGS.guestNewsFeed} component={GuestNewsFeed} />
          <Route exact path={ROUTE_STRINGS.guestGlobalDifferentials} component={GlobalDifferentials} />
          <Route exact path={ROUTE_STRINGS.supportRequest} component={SupportRequest} />
          <Route exact path={ROUTE_STRINGS.aboutUs} component={AboutUs} />
          <Route exact path={ROUTE_STRINGS.guestCoffeeQuotes} component={CoffeeQuotes} />
          <Route exact path={ROUTE_STRINGS.aboutMobileView} component={AboutUs} />
          <Route exact path={ROUTE_STRINGS.coffeeReportsGuest} component={CoffeeStockReports} />
          <Route exact path={ROUTE_STRINGS.guestglobalrawcoffeeprices} component={GlobalRawCoffeePrices} />
          <Route exact path={ROUTE_STRINGS.guestUserGuide} component={UserGuide} />
          <Route exact path={ROUTE_STRINGS.billionaireBrewGuest} component={BillionaireBrew} />
          <Route exact path={ROUTE_STRINGS.guestCoffeeWebAi} component={CoffeeWebAi} />
          <Route exact path={ROUTE_STRINGS.guestCoffeeGames} component={CoffeeWebQuiz} />
          <Route exact path={ROUTE_STRINGS.guestWeather} component={Weather} />
          <Route exact path={ROUTE_STRINGS.guestYourNews} component={YourNews} />
          <Route exact path={ROUTE_STRINGS.guestGlobalFreightRates} component={GlobalFreightRates} />
          <Route exact path={ROUTE_STRINGS.guestCoffeeExchange} component={CoffeeExchange} />
          <Route exact path={ROUTE_STRINGS.guestCoffeeTrade} component={CoffeeTradeBox} />
          <Route exact path={ROUTE_STRINGS.guestCoffeeApps} component={CoffeeApps} />
          <Route exact path={ROUTE_STRINGS.guestCoffeePedia} component={CoffeePedia} />

          {/* Kept it for future reference */}
          {/* <Route exact path="/redirect" component={SharedNewsRedirection} /> */}
          <Route exact path="/news/:id">
            <NewsFeedLink />
          </Route>
          <Route exact path={ROUTE_STRINGS.login} component={AuthScreens} />
          <Route exact path={ROUTE_STRINGS.createAccount} component={AuthScreens} />
          {/* Protected Routes */}
          <Route exact path="/dashboard"></Route>
          <Route exact path={ROUTE_STRINGS.coffeeweb} component={CoffeeWebSocial} />
          <Route exact path={ROUTE_STRINGS.coffeequotes} component={CoffeeQuotes} />
          <Route exact path={ROUTE_STRINGS.coffeeNewsFeeds} component={CoffeeNewsFeeds} />
          <Route exact path={RouteStrings.notification} component={Notification} />
          <Route exact path={RouteStrings.opennewsnotification} component={OpenNewsNotification} />
          <Route exact path={RouteStrings.opensharednews} component={OpenSharedNews} />
          <Route exact path={ROUTE_STRINGS.subscription} component={Subscription} />
          <Route exact path={ROUTE_STRINGS.paymentgateway} component={PaymentGateWay} />
          <Route exact path={ROUTE_STRINGS.success} component={PaymentStatus} />
          <Route exact path={ROUTE_STRINGS.cancel} component={PaymentStatus} />
          <Route exact path={ROUTE_STRINGS.support} component={SupportRequest} />
          <Route exact path={ROUTE_STRINGS.globaldifferentials} component={GlobalDifferentials} />
          <Route exact path={ROUTE_STRINGS.globalrawcoffeeprices} component={GlobalRawCoffeePrices} />
          <Route exact path={ROUTE_STRINGS.aboutUsCoffeeWeb} component={AboutUs} />
          <Route exact path={ROUTE_STRINGS.coffeeReports} component={CoffeeStockReports} />
          <Route exact path={ROUTE_STRINGS.billionaireBrew} component={BillionaireBrew} />
          <Route exact path={ROUTE_STRINGS.userGuide} component={UserGuide} />
          <Route exact path={ROUTE_STRINGS.coffeeWebAi} component={CoffeeWebAi} />
          <Route exact path={ROUTE_STRINGS.coffeeGames} component={CoffeeGames} />
          <Route exact path={ROUTE_STRINGS.weather} component={Weather} />
          <Route exact path={ROUTE_STRINGS.yourNews} component={YourNews} />
          <Route exact path={ROUTE_STRINGS.coffeeCart} component={CoffeeCart} />
          <Route exact path={ROUTE_STRINGS.coffeePost} component={CoffeePostScreen} />
          <Route exact path={ROUTE_STRINGS.coffeeCafes} component={CoffeeCafes} />
          <Route exact path={ROUTE_STRINGS.globalFreightRates} component={GlobalFreightRates} />
          <Route exact path={ROUTE_STRINGS.coffeeTrade} component={CoffeeTradeBox} />
          <Route exact path={ROUTE_STRINGS.coffeeExchange} component={CoffeeExchange} />
          <Route exact path={ROUTE_STRINGS.coffeePedia} component={CoffeePedia} />
          <Route exact path={ROUTE_STRINGS.coffeeApps} component={CoffeeApps} />
          <Route exact path={ROUTE_STRINGS.pnf} component={PageNotFound} />
          <Route path="*" component={PageNotFound} />
        </Switch>
      </LayoutContainer>

      {showFooter && !window.location.pathname.includes('coffee_reports') && !hideViews.includes(view) && <FooterDashboard />}
    </div>
  )
}

export default Routes
